import { DsBadgeTheme } from '@design-system/ds-badge/types/ds-badge-theme.type';
import { FileAttachmentTagStatuses } from '@enums/file-attachment-tag.enum';
import { RecordOriginBadgeInterface } from '@interfaces/record-origin-badge.interface';

/** Entity the file was uploaded from — service request level. Backend spelling — do not correct. */
export const FILE_UPLOADED_FROM_SERVICE_REQUEST = 'Itinary';

/** Entity the file was uploaded from — leg (service request step) level. */
export const FILE_UPLOADED_FROM_LEG = 'ServiceRequestStep';

/**
 * File attachment tag -> badge theme. Single source of truth for every screen that renders a file
 * tag, so the same tag never gets two colors (the v2 Notes & Files table and the View Files modal
 * used to disagree on all of them). These are the themes the View Files modal already used: it is
 * shared with the legacy screens, so keeping its palette leaves them untouched.
 */
export const FILE_TAG_BADGE_THEMES: Readonly<Record<string, DsBadgeTheme>> = {
  [FileAttachmentTagStatuses.flightRequestForm]: 'blue',
  [FileAttachmentTagStatuses.aviationSpecialistApproval]: 'indigo',
  [FileAttachmentTagStatuses.airCharterQuote]: 'purple',
  [FileAttachmentTagStatuses.airCharterItinerary]: 'blue-light',
  [FileAttachmentTagStatuses.organSpecimenPhoto]: 'pink',
  [FileAttachmentTagStatuses.flightCostCalculator]: 'orange',
  [FileAttachmentTagStatuses.cateringReceipt]: 'success',
};

/** Default badge theme for a tag the map does not know. */
export const FILE_TAG_BADGE_FALLBACK_THEME: DsBadgeTheme = 'gray';

/**
 * `uploadedFrom` value -> origin badge shown next to the file name. `primary` is what the View Files
 * modal used, so the legacy screens sharing it keep the badge they had.
 */
export const FILE_ORIGIN_BADGES: Readonly<Record<string, RecordOriginBadgeInterface>> = {
  [FILE_UPLOADED_FROM_SERVICE_REQUEST]: { label: 'SR File', theme: 'primary' },
  [FILE_UPLOADED_FROM_LEG]: { label: 'Leg File', theme: 'success' },
};
